// extracted by mini-css-extract-plugin
module.exports = {"heovza6":"heovza6","hao-posts":"hao-posts","f1l0v6x6":"f1l0v6x6","section-aside-container":"section-aside-container"};